export const zhCN = {
  'errors.apiKeyEmpty': 'apiKey 不能为空',
  'errors.baseUrlEmpty': 'baseUrl 为必填项 — 生产环境请传入 XMAX_OPEN_API_PRODUCTION_BASE_URL',
  'errors.modelEmpty': 'model 不能为空',
  'errors.invalidJson': '响应不是有效的 JSON',
  'errors.invalidPayload': '响应数据格式不正确',
  'errors.requestFailed': '请求失败',
  'errors.requestRetry': '请求失败，请稍后再试',
  'errors.networkError': '网络遇到点问题，请稍后再试',
  'errors.requestTimeout': '请求超时',
  'errors.invalidFile': '上传失败：文件无效，请重新选择后再试',
  'errors.invalidFileType': '上传失败：文件格式不支持，请重新选择',
  'errors.sessionJoinInfoIncomplete': 'session 缺少完整的 RTC 进房信息',
  'errors.sessionUidMissing': 'session 缺少 sessionUid',
  'errors.refImageMissing': '缺少参考图',
  'errors.imageCheckMissingUrl': '图片检查响应缺少 url',
  'errors.imageCheckUnsafe': '图片未通过安全检查',
  'errors.captureStreamUnsupported': '当前浏览器不支持 captureStream',
  'errors.videoTrackMissing': '未能从视频文件创建 video track',
  'errors.imageTrackMissing': '未能从图片文件创建 video track',
  'errors.imageLoadFailed': '图片无法加载，请重新选择文件后再试',
  'errors.invalidMediaFileType': '不支持的媒体文件类型：{type}',
  'errors.videoPlaybackFailed': '视频无法开始播放，请重新选择文件后再试',
  'errors.rtcNotJoined': '请先成功加入 RTC 房间',
  'errors.rtcNotJoinedForMessaging': '请先成功加入 RTC 房间后再发送事件',
  'errors.systemOverloaded': '网络连接失败，请重试',
  'errors.rtcStreamInterrupted': '实时音视频传输中断，请重新连接',
  'errors.offlinePositiveNumber': '{label} 必须大于 0',
  'errors.offlineTaskUidEmpty': 'taskUid 不能为空',
  'errors.offlineUploadedUrlRequired': '{label} 必须是 Xmax 上传方法返回的 URL',
  'errors.offlineQualityInvalid': 'quality 必须是 sd 或 hd',
  'errors.offlineFpsUnsupported': '离线任务接口不支持该 fps',
  'errors.offlinePromptInvalid': 'context.prompt 长度必须为 1 至 1024 个字符',
  'errors.offlineTaskUidsInvalid': 'taskUids 必须包含 1 至 100 个任务 ID',
  'errors.offlinePageNumberInvalid': 'pageNumber 必须是正整数',
  'errors.offlinePageSizeInvalid': 'pageSize 必须是 1 至 100 的整数',
  'errors.offlineStatusInvalid': '离线任务接口不支持该 status',
  'errors.offlineTaskTimeout': '离线任务未能在 {timeoutMs} 毫秒内完成',

  'notices.lowInputResolution': '当前输入视频分辨率过低，建议更换高清视频源后重试',
  'notices.lowInputImageResolution': '当前输入图片分辨率过低，建议更换高清图片后重试',

  'rtc.alreadyInRoom': 'RTC 已在目标房间中，跳过重复进房',
  'rtc.joiningRoom': '准备加入 RTC 房间',
  'rtc.joinSuccess': 'RTC joinRoom 成功',
  'rtc.roomUsers': '当前房间用户: {users}',
  'rtc.localVideoAlreadyPublished': '本地视频已处于发布状态',
  'rtc.localVideoPublished': '已开启本地视频采集并发布视频流',
  'rtc.externalVideoPublished': '已发布自定义视频流',
  'rtc.localVideoStopped': '已停止本地视频发布',
  'rtc.leaveRoomError': 'RTC leaveRoom 过程中出现异常',
  'rtc.engineDestroyed': 'RTC 引擎已销毁',
  'rtc.roomEventSent': '已发送 RTC 事件',
  'rtc.remotePlayerRefreshed': '已刷新远端视频播放器: {userId}',
  'rtc.remotePlayerRefreshFailed': '刷新远端视频播放器失败',
  'rtc.userJoined': '用户加入 RTC 房间: {userId}',
  'rtc.userLeft': '用户离开 RTC 房间: {userId}',
  'rtc.connectionStateChanged': 'RTC 连接状态变化',
  'rtc.userPublished': '用户发布流: {userId}',
  'rtc.userUnpublished': '用户取消发布流: {userId}',
  'rtc.seiReceived': '收到远端 SEI: {userId}',
  'rtc.error': 'RTC 错误: {code}',
  'rtc.captureSizeSet': '已设置本地视频采集尺寸: {width} x {height}',
  'rtc.encoderPreferenceSet': '已设置视频编码偏好为 H.264',
  'rtc.encoderPreferenceFailed': '设置视频编码偏好失败',
  'rtc.remoteWaitSei': '远端视频等待 SEI 放行: {userId}',
  'rtc.remoteContainerNotReady': '远端视频容器未就绪，跳过绑定',
  'rtc.remotePlayerBound': '已绑定远端视频播放器: {userId}',
  'rtc.remoteOutputStalled': '远端输出超过 20 秒无新帧',
  'rtc.sendSeiFailed': '发送 SEI 失败，当前浏览器或编码配置可能不支持该能力',
  'rtc.seiUnsupported': '当前环境不支持 H.264，SEI gate 将不会生效，output 将不再被拦截',
  'rtc.seiGateFallback': 'SEI 门控超时，已显示远端输出',
  'rtc.getCodecsFailed': '获取浏览器编解码支持失败，SEI gate 将不会生效，output 将不再被拦截',
} as const
